import { Component, EventEmitter, Input, Output } from '@angular/core';

// "Your saved preferences" card in the right panel (specs/ai-agent-home-redesign US-11).
// Read-only summary; Edit opens the preferences dialog owned by the parent.
@Component({
  selector: 'app-agent-prefs-card',
  templateUrl: './agent-prefs-card.component.html',
  styleUrls: ['./agent-prefs-card.component.scss'],
})
export class AgentPrefsCardComponent {
  @Input() agentName = '';
  @Input() preferences: string[] = [];
  @Output() edit = new EventEmitter<void>();
}
